module.exports = "https://cdn.thelire.com/ins/resource/sp_place_n@3x.19e592f90dc141c352d917dde7652207.png";